import { Component } from '@angular/core';

@Component({
    standalone: true,
    selector: 'app-footer',
    template: `<div class="layout-footer">
        co.solution by <a href="https://roya.marketing/index.html" target="_blank" rel="noopener noreferrer" class="text-primary font-bold hover:underline">Roya Marketing</a>
    </div>`
})
export class AppFooter {}
